import dayjs, { type Dayjs } from 'dayjs';
import { getJewishDay } from 'jewish-dates-core';
import type { BasicJewishDay } from 'react-jewish-datepicker';

/** Strip time from API values (`2024-01-15T00:00:00` → `2024-01-15`). */
export function normalizeGregorianDate(value?: string): string {
  if (!value) return '';
  return value.includes('T') ? value.split('T')[0] : value;
}

export function gregorianToBasicJewishDay(gregorianDate?: string): BasicJewishDay | null {
  const normalized = normalizeGregorianDate(gregorianDate);
  if (!normalized) return null;
  try {
    return getJewishDay(dayjs(normalized) as Dayjs);
  } catch {
    return null;
  }
}

/** Gregorian `YYYY-MM-DD` from a Jewish calendar day (optional −1 day after sunset). */
export function gregorianFromJewishDate(date: Date, afterSunset = false): string {
  const base = dayjs(date).startOf('day');
  return afterSunset ? base.subtract(1, 'day').format('YYYY-MM-DD') : base.format('YYYY-MM-DD');
}

export function basicJewishDayToGregorian(day: BasicJewishDay, afterSunset = false): string {
  return gregorianFromJewishDate(day.date, afterSunset);
}

export function gregorianToHebrewString(gregorianDate: string): string | null {
  const jewishDay = gregorianToBasicJewishDay(gregorianDate);
  return jewishDay?.jewishDateStrHebrew ?? null;
}
